/**
 * We need this separate file because this is shared between the service worker and the content script,
 * and the content script should not import APIs that is not allowed to use.
 */

// Time to wait for the verdict to be resolved and restoring the page content when getting it
export const VERDICT_TIMEOUT_MS = 5000;
